import { render } from "./thankyou-driver.vue?vue&type=template&id=3ace78c9&scoped=true"
import script from "./thankyou-driver.vue?vue&type=script&lang=js"
export * from "./thankyou-driver.vue?vue&type=script&lang=js"

import "./thankyou-driver.vue?vue&type=style&index=0&id=3ace78c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ace78c9"]])

export default __exports__